<!-- How It Works Section -->
<section
  class="py-24 bg-slate-50 border-t border-slate-200/60"
  aria-labelledby="how-it-works-heading"
>
  <div class="container mx-auto px-6">
    <!-- Section Header -->
    <div class="text-center max-w-3xl mx-auto mb-16 space-y-4">
      <div
        class="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wider"
      >
        <i class="fa-solid fa-list-check"></i>
        <span>Simple 4-Step Process</span>
      </div>
      <h2
        id="how-it-works-heading"
        class="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight"
      >
        Your Journey To Academic Excellence
      </h2>
      <p class="text-lg text-slate-600 leading-relaxed">
        Four simple steps to get started, join live interactive classes, and achieve your educational goals.
      </p>
    </div>

    <!-- Steps Grid -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
      
      <!-- Step 1 -->
      <div
        class="daisy-card bg-white border border-slate-200/80 p-8 rounded-2xl text-center relative shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1"
      >
        <div class="relative mb-6">
          <div
            class="w-16 h-16 bg-blue-100 text-blue-600 rounded-2xl flex items-center justify-center mx-auto text-2xl font-bold"
          >
            <i class="fa-solid fa-magnifying-glass"></i>
          </div>
          <span
            class="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-blue-600 text-white font-black text-xs flex items-center justify-center border-2 border-white shadow-sm"
          >
            1
          </span>
        </div>
        <h3 class="text-xl font-bold text-slate-900 mb-2">
          Explore Courses
        </h3>
        <p class="text-slate-600 text-sm leading-relaxed">
          Browse through our comprehensive directory of subject modules, live Zoom classes, and verified tutors.
        </p>
      </div>

      <!-- Step 2 -->
      <div
        class="daisy-card bg-white border border-slate-200/80 p-8 rounded-2xl text-center relative shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1"
      >
        <div class="relative mb-6">
          <div
            class="w-16 h-16 bg-purple-100 text-purple-600 rounded-2xl flex items-center justify-center mx-auto text-2xl font-bold"
          >
            <i class="fa-solid fa-user-plus"></i>
          </div>
          <span
            class="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-purple-600 text-white font-black text-xs flex items-center justify-center border-2 border-white shadow-sm"
          >
            2
          </span>
        </div>
        <h3 class="text-xl font-bold text-slate-900 mb-2">
          Create Free Account
        </h3>
        <p class="text-slate-600 text-sm leading-relaxed">
          Register in less than two minutes to access your student dashboard and manage your enrolled classes.
        </p>
      </div>

      <!-- Step 3 -->
      <div
        class="daisy-card bg-white border border-slate-200/80 p-8 rounded-2xl text-center relative shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1"
      >
        <div class="relative mb-6">
          <div
            class="w-16 h-16 bg-emerald-100 text-emerald-600 rounded-2xl flex items-center justify-center mx-auto text-2xl font-bold"
          >
            <i class="fa-solid fa-video"></i>
          </div>
          <span
            class="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-emerald-600 text-white font-black text-xs flex items-center justify-center border-2 border-white shadow-sm"
          >
            3
          </span>
        </div>
        <h3 class="text-xl font-bold text-slate-900 mb-2">
          Join Live Sessions
        </h3>
        <p class="text-slate-600 text-sm leading-relaxed">
          Attend scheduled live classes directly via integrated Zoom links, participate in discussions, and ask questions.
        </p>
      </div>

      <!-- Step 4 -->
      <div
        class="daisy-card bg-white border border-slate-200/80 p-8 rounded-2xl text-center relative shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1"
      >
        <div class="relative mb-6">
          <div
            class="w-16 h-16 bg-amber-100 text-amber-600 rounded-2xl flex items-center justify-center mx-auto text-2xl font-bold"
          >
            <i class="fa-solid fa-trophy"></i>
          </div>
          <span
            class="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-amber-500 text-white font-black text-xs flex items-center justify-center border-2 border-white shadow-sm"
          >
            4
          </span>
        </div>
        <h3 class="text-xl font-bold text-slate-900 mb-2">
          Excel & Succeed
        </h3>
        <p class="text-slate-600 text-sm leading-relaxed">
          Review recordings, solve past paper sets, track your progress, and achieve top grades in your exams.
        </p>
      </div>

    </div>

    <!-- Bottom Action Button -->
    <div class="text-center">
      <a
        routerLink="/auth/register"
        class="daisy-btn daisy-btn-primary daisy-btn-lg bg-blue-600 hover:bg-blue-500 text-white border-none px-10 rounded-2xl shadow-lg shadow-blue-500/20 inline-flex items-center gap-2"
      >
        <i class="fa-solid fa-rocket"></i>
        <span>Start Your Learning Journey</span>
        <i class="fa-solid fa-arrow-right text-xs"></i>
      </a>
    </div>

  </div>
</section>
